import { render, staticRenderFns } from "./CompanyRfxResponseHistory.vue?vue&type=template&id=27bbec45"
import script from "./CompanyRfxResponseHistory.vue?vue&type=script&lang=js"
export * from "./CompanyRfxResponseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports